import { UnitWorkloadAcademicAssignment } from './UnitWorkloadAcademicAssignment';
import { UnitWorkloadCampusAssignment } from './UnitWorkloadCampusAssignment';
import { Academic, UnitWorkloadCampus, UnitWorkloadDetails } from '#server/models';

export interface Campus {
  id: number;
  name: string;
  studyModeName: string;
}

export interface UnitWorkloadAssignmentProps {
  unitWorkloadDetails: UnitWorkloadDetails;
  academicList?: Academic[] | undefined;
  unitWorkloadCampuses?: UnitWorkloadCampus[] | undefined;
  assignedAcademics?: { academicWorkload: Academic }[] | undefined; //TODO: there is no need to have property academicWorkload here, it can be just Academic[]
  campusList?: Campus[] | undefined;
}

export const UnitWorkloadAssignment = ({
  unitWorkloadDetails,
  unitWorkloadCampuses,
  assignedAcademics,
  campusList,
}: UnitWorkloadAssignmentProps) => {
  return (
    <div className="pl-15 flex basis-4/5 flex-row justify-start gap-10 bg-white py-10 pr-10">
      <UnitWorkloadAcademicAssignment
        unitWorkloadDetails={unitWorkloadDetails}
        unitWorkloadCampuses={unitWorkloadCampuses}
        assignedAcademics={assignedAcademics}
      />
      <UnitWorkloadCampusAssignment
        unitWorkloadDetails={unitWorkloadDetails}
        unitWorkloadCampuses={unitWorkloadCampuses}
        campusList={campusList}
      />
    </div>
  );
};
